// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const arctibax: PokeData = {
  "id": 997,
  "name": "arctibax",
  "height": 8,
  "weight": 300,
  "base_experience": 148,
  "types": [
    PokeType.DRAGON,
    PokeType.ICE
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "leer",
    "bite",
    "ice-beam",
    "focus-energy",
    "icy-wind",
    "dragon-breath",
    "crunch",
    "ice-fang",
    "dragon-tail",
    "icicle-crash"
  ],
  "moves": [
    "tackle",
    "leer",
    "bite",
    "dragon-breath",
    "crunch",
    "ice-fang",
    "ice-shard",
    "hailstorm",
    "dragon-dance",
    "chilly-reception",
    "inner-spirit",
    "outrage",
    "scale-shot"
  ],
  "evolution_chain": {
    "id": 527,
    "item": null,
    "species": [
      {
        "name": "frigibax",
        "order": 949,
        "types": [
          PokeType.DRAGON,
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "arctibax",
        "order": 950,
        "types": [
          PokeType.DRAGON,
          PokeType.ICE
        ],
        "evolves_from_species_id": 996,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "baxcalibur",
        "order": 951,
        "types": [
          PokeType.DRAGON,
          PokeType.ICE
        ],
        "evolves_from_species_id": 997,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 54,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 77.75,
    "speed": 62,
    "ability_power": 95
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
